export const name = "ST_INTERSECTS";
export const summary = `Checks if at least one point appears in two \`GEOGRAPHY\` values.`;
export const reference = `
## ST_INTERSECTS

Checks if at least one point appears in two \`GEOGRAPHY\` values.

\`\`\`
ST_INTERSECTS(geography_1, geography_2)
\`\`\`

### Description

Returns \`TRUE\` if the point set intersection of \`geography_1\` and \`geography_2\`is non-empty. Thus, this function returns \`TRUE\` if there is at least one point that appears in both input \`GEOGRAPHY\`s.

If \`ST_INTERSECTS\` returns \`TRUE\`, it implies that \`ST_DISJOINT\`returns \`FALSE\`.


### Return type

\`BOOL\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
